import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { DELETE, DELETE_SUCCESS, DELETE_FAILED } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"
import { LOGIN_SUCCESS } from "../Authentication/actionTypes"

export const deleteRecord = (id, inputValue) => async dispatch => {
  dispatch({
    type: DELETE
  })
  
  try {
    let response = await api(`delete/deleteRecord`, 'delete', { id, inputValue }, getAuthHeader())
    if (inputValue && inputValue.includes('leave')) {
      const existingUser = JSON.parse(localStorage.getItem("user")) || {};
      
      if (response?.data?.employeeId) {
        const responseEmployeeId = String(response.data.employeeId);
        const currentUserId = String(existingUser.id);
        if (responseEmployeeId === currentUserId) {
          const totalCasualRestored = parseFloat(response.data.totalCasual) || 0;
          const totalUnpaidRestored = parseFloat(response.data.totalUnpaid) || 0;
          const currentCasualLeave = parseFloat(existingUser.casual_leave) || 0;
          const currentUnpaidLeave = parseFloat(existingUser.unpaid_leave) || 0;
          const updatedCasualLeave = currentCasualLeave + totalCasualRestored;
          const updatedUnpaidLeave = Math.max(0, currentUnpaidLeave - totalUnpaidRestored);
          
          const updatedUser = { 
            ...existingUser, 
            casual_leave: updatedCasualLeave.toFixed(2),
            unpaid_leave: updatedUnpaidLeave.toFixed(2)
          };
          
  
          localStorage.setItem("user", JSON.stringify(updatedUser));
          dispatch({
            type: LOGIN_SUCCESS,
            payload: updatedUser
          });
          
        } else {
          console.log("Employee ID mismatch - localStorage not updated:", {
            responseEmployeeId,
            currentUserId
          });
        }
      } else {
        console.log("Missing employeeId in response - localStorage not updated");
      }
    } else {
      console.log("Not a leave deletion, inputValue:", inputValue);
    }
    
    dispatch({
      type: DELETE_SUCCESS,
      payload: response?.data
    });
    
    return response;
    
  } catch (error) {
    console.log("Error while deleting:", error);
    toast.error(error?.message || "Failed to delete record");
    
    return dispatch({
      type: DELETE_FAILED,
      payload: error?.message
    });
  }
}